// Types
import type { Media } from '../../../server/src/types/media.types';

// Utils
import { sortByComparators } from 'utils/sortByComparators';

export const sortMedia = (
  media: Media[] | undefined,
  sortBy: string
): Media[] => {
  return sortByComparators(media, sortBy, {
    naziv: (a, b) => a.fileName.localeCompare(b.fileName),
    'naziv-desc': (a, b) => b.fileName.localeCompare(a.fileName),
    datum: (a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    'datum-desc': (a, b) =>
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  });
};
